/* eslint-disable */
import axios from '@/axios.js';

export const diseaseApi = {
  getDiseases(payload) {
    return axios.get('admin/dna/diseases?join=category', {
      params: payload,
    });
  },
  getDisease(id) {
    return axios.get(`admin/dna/diseases/${id}?join=translations`);
  },
  addDisease(body) {
    return axios.post(`admin/dna/diseases`, body);
  },
  updateDisease(id, body) {
    return axios.patch(`admin/dna/diseases/${id}`, body);
  },
  getCategories() {
    return axios.get('admin/dna/categories?limit=100');
  },
};
